// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3OGiD","title":"Header_title__3K9N2","left":"Header_left__2vqUg","clinicName":"Header_clinicName__2nKy6"};